/**
 * Shared Instagram feed fetch for modal + homepage rail.
 * One in-flight request per API URL so phone network is not doubled.
 */
(function () {
  'use strict';

  if (window.WOMInstagramFeed) return;

  var cache = {};

  function collectUrls(data) {
    var urls = [];
    if (!data || typeof data !== 'object') return urls;
    if (Array.isArray(data)) return data.filter(function (u) { return typeof u === 'string'; });
    if (Array.isArray(data.instagram_urls)) urls = urls.concat(data.instagram_urls);
    if (Array.isArray(data.images)) urls = urls.concat(data.images);
    if (Array.isArray(data.data)) urls = urls.concat(data.data);
    return urls.filter(function (u) {
      return typeof u === 'string' && u.indexOf('instagram.com') !== -1;
    });
  }

  function log(msg, detail) {}

  function get(apiUrl) {
    if (!apiUrl) {
      return Promise.resolve([]);
    }
    if (cache[apiUrl]) {
      log('reuse cached/in-flight Instagram API', { url: apiUrl });
      return cache[apiUrl];
    }

    var t0 = performance.now();
    log('Instagram API called (shared)', { url: apiUrl });

    cache[apiUrl] = fetch(apiUrl, {
      headers: { Accept: 'application/json', 'ngrok-skip-browser-warning': 'true' },
      cache: 'no-store'
    })
      .then(function (r) {
        log('Instagram API HTTP response', {
          status: r.status,
          ok: r.ok,
          ms: Math.round(performance.now() - t0)
        });
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        var urls = collectUrls(data);
        log('Instagram API body parsed', {
          urls: urls.length,
          ms: Math.round(performance.now() - t0),
          sample: urls.slice(0, 2)
        });
        return urls;
      })
      .catch(function (err) {
        delete cache[apiUrl];
        log('Instagram API FAILED', {
          ms: Math.round(performance.now() - t0),
          error: String(err && err.message ? err.message : err)
        });
        return [];
      });

    return cache[apiUrl];
  }

  window.WOMInstagramFeed = {
    get: get,
    collectUrls: collectUrls
  };
})();
